import { render, staticRenderFns } from "./EsamiStrumentaliEdit.vue?vue&type=template&id=b4643b4c&scoped=true"
import script from "./EsamiStrumentaliEdit.vue?vue&type=script&lang=js"
export * from "./EsamiStrumentaliEdit.vue?vue&type=script&lang=js"
import style0 from "./EsamiStrumentaliEdit.vue?vue&type=style&index=0&id=b4643b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4643b4c",
  null
  
)

export default component.exports